import React, { useState, useContext } from 'react';
import { navigate } from '@reach/router';
import logo from '../../images/logo.png';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { BsFillMegaphoneFill, BsFillPersonFill } from "react-icons/bs";
import axios from 'axios';
import { Link } from '@reach/router';
import NavItem from 'react-bootstrap/esm/NavItem';

import { Context as UserContext } from '../../context/UserContext';
import Announcement from './Announcement';

const Navbar = () => {
    const [user, setUser] = useContext(UserContext); //use user from context
    const [showPopup, setShowPopup] = useState(false);
    const handleOpen = () => setShowPopup(true);
    const handleClose = () => setShowPopup(false);

    //const [, setUser] = useContext(UserContext); (No use for this)

    const handleLogout = () => {
        axios
            .get('/api/logout', { withCredentials: true })
            .then((res) => {
                setUser(null)
                navigate('/')
            })
            .catch((e) => {
                console.log('error: ', e)
            });
    };
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/">
                        <img src={logo} className="logo" alt="" />
                    </Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav ms-auto">
                            {user && (      //adding navbar links inside a user conditional
                                <>
                                    <NavItem as="li">
                                        <Link className="nav-link" to="/about">
                                            About PCSS
                                        </Link>
                                    </NavItem>
                                    <NavItem as="li">
                                        <Link className="nav-link" to="/help">
                                            Help
                                        </Link>
                                    </NavItem>
                                    <Nav.Link onClick={handleOpen}>
                                        <BsFillMegaphoneFill />
                                    </Nav.Link>
                                    <NavDropdown
                                        id="nav-dropdown-dark-example"
                                        title={<BsFillPersonFill />}
                                        menuVariant="dark"
                                    >
                                        <NavDropdown.Item onClick={handleLogout}>
                                            Log out
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </>
                            )}
                        </ul>
                    </div>
                </div>
            </nav>
            <Announcement showPopup={showPopup} handleClose={handleClose} />
        </>
    );
};

export default Navbar;